/**
 * Reads a boolean visibility flag from the first source object that defines it.
 * Defaults to true when no source has the key (backward compatible).
 */
export function resolveVisibilityFlag(key, sources) {
    for (const source of sources) {
        if (source == null || typeof source !== 'object') {
            continue;
        }
        if (!Object.prototype.hasOwnProperty.call(source, key)) {
            continue;
        }
        const value = source[key];
        if (value === false || value === 0 || value === '0') {
            return false;
        }
        if (value === true || value === 1 || value === '1') {
            return true;
        }
        if (typeof value === 'string') {
            const normalized = value.trim().toLowerCase();
            if (['false', 'no', 'off'].includes(normalized)) {
                return false;
            }
            if (['true', 'yes', 'on'].includes(normalized)) {
                return true;
            }
        }
    }
    return true;
}

/**
 * Whether discount labels/amounts should appear on orders, invoices, and share text.
 */
export function shouldShowPriceDiscounts(...sources) {
    return resolveVisibilityFlag('show_price_discounts', sources);
}

export default shouldShowPriceDiscounts;
